import { render, staticRenderFns } from "./Licences.vue?vue&type=template&id=3f64edcb&"
import script from "./Licences.vue?vue&type=script&lang=ts&"
export * from "./Licences.vue?vue&type=script&lang=ts&"
import style0 from "./Licences.vue?vue&type=style&index=0&id=3f64edcb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports